var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-static-top"},[_c('div',{staticClass:"container-fluid text-center m-0"},[_c('div',{staticClass:"navbar-brand w-100"},[_c('img',{staticClass:"cs_logo",attrs:{"src":'/image/cs_logo_light.png',"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }